@if (editable) {
  @if (editModeEnabled && formControl) {
    <div (keydown.enter)="save()" (keydown.escape)="cancel()" class="edit-group" pFocusTrap>
      @switch (type) {
        @case ('date') {
          <p-datepicker
            (onBlur)="onBlur()"
            [defaultDate]="defaultDate"
            [formControl]="formControl"
            [maxDate]="maxDate"
            [minDate]="minDate"
            [pTooltip]="'ERRORS.' + error | translate"
            [showButtonBar]="true"
            [tooltipDisabled]="!error"
            appendTo="body"
            dateFormat="dd.mm.yy"
            tooltipEvent="focus"
            tooltipPosition="top"
            tooltipStyleClass="error"></p-datepicker>
        }
        @case ('boolean') {
          <p-toggleswitch [formControl]="formControl"></p-toggleswitch>
        }
        @case ('percent') {
          <p-inputNumber
            (onBlur)="onBlur()"
            [formControl]="formControl"
            [locale]="'de-CH'"
            [max]="100"
            [maxFractionDigits]="2"
            [min]="0"
            [minFractionDigits]="2"
            [showButtons]="false"
            [suffix]="'%'"></p-inputNumber>
        }
        @case ('datetime') {
          <p-datepicker
            (onBlur)="onBlur()"
            [defaultDate]="defaultDate"
            [formControl]="formControl"
            [maxDate]="maxDate"
            [minDate]="minDate"
            [pTooltip]="'ERRORS.' + error | translate"
            [showButtonBar]="true"
            [showTime]="true"
            [tooltipDisabled]="!error"
            appendTo="body"
            dateFormat="dd.mm.yy"
            tooltipEvent="focus"
            tooltipPosition="top"
            tooltipStyleClass="error"></p-datepicker>
        }
        @case ('time') {
          <p-datepicker [formControl]="formControl" [timeOnly]="true" appendTo="body"></p-datepicker>
        }
        @case ('number') {
          <p-inputNumber
            (onBlur)="onBlur()"
            [formControl]="formControl"
            [locale]="'de-CH'"
            [minFractionDigits]="1"
            [pTooltip]="'ERRORS.' + error | translate"
            [tooltipDisabled]="!error"
            [useGrouping]="false"
            tooltipEvent="focus"
            tooltipPosition="top"
            tooltipStyleClass="error"></p-inputNumber>
        }
        @case ('integer') {
          <p-inputNumber
            (onBlur)="onBlur()"
            [formControl]="formControl"
            [locale]="'de-CH'"
            [maxFractionDigits]="0"
            [minFractionDigits]="0"
            [pTooltip]="'ERRORS.' + error | translate"
            [tooltipDisabled]="!error"
            [useGrouping]="false"
            tooltipEvent="focus"
            tooltipPosition="top"
            tooltipStyleClass="error"></p-inputNumber>
        }
        @default {
          @if (options) {
            <p-select
              [filter]="true"
              [formControl]="formControl"
              [options]="options"
              [placeholder]="'-'"
              [showClear]="!required"
              appendTo="body"
              appScrollIntoView></p-select>
          } @else {
            <!-- (keydown.space) is required, because of a bug: https://github.com/primefaces/primeng/issues/14531 -->
            <input
              (keydown.space)="$event.stopPropagation()"
              [formControl]="formControl"
              [pTooltip]="'ERRORS.' + error | translate"
              [tooltipDisabled]="!error"
              pInputText
              tooltipEvent="focus"
              tooltipPosition="top"
              tooltipStyleClass="error"
              type="text" />
          }
        }
      }
      @if (column?.fastEdit !== true) {
        <button
          (click)="save()"
          [disabled]="!formControl.valid"
          class="p-button-primary"
          icon="fal fa-check"
          pButton
          type="button"></button>
        <button (click)="cancel()" class="p-button-secondary" icon="fal fa-times" pButton type="button"></button>
      }
    </div>
  } @else {
    <div
      (click)="enableEditMode()"
      (keydown.enter)="enableEditMode()"
      [class.changed]="changed"
      [class.error]="error"
      [pTooltip]="'ERRORS.' + error | translate"
      [tooltipDisabled]="!error"
      class="editable"
      tabindex="0"
      tooltipPosition="top"
      tooltipStyleClass="error">
      <ng-container *ngTemplateOutlet="view"></ng-container>
    </div>
  }
} @else {
  <div class="view">
    <ng-container *ngTemplateOutlet="view"></ng-container>
  </div>
}

<ng-template #view>
  @switch (type) {
    @case ('date') {
      {{ value | date: 'dd.MM.yyyy' }}
    }
    @case ('boolean') {
      <div style="text-align: center; width: 100%">
        @if (!!value) {
          <i class="fal fa-check"></i>
        } @else {
          <i class="fal fa-minus"></i>
        }
      </div>
    }
    @case ('datetime') {
      {{ value | date: 'dd.MM.yyyy HH:mm:ss' }}
    }
    @case ('time') {
      {{ formatTime(value) }}
    }
    @case ('percent') {
      {{ formatPercent(value) }}
    }
    @case ('number') {
      <span [style]="{ color: column?.color }">{{ formatNumber(value) }}</span>
    }
    @case ('dateRangeAssignment') {
      <div style="text-align: center; width: 100%">
        @if (value && value[0]?.from && !value[0]?.to) {
          <i class="fal fa-arrow-right"></i>
        }
        @if (value && value[0]?.from && value[0]?.to) {
          <i class="fal fa-arrow-to-right"></i>
        }
      </div>
    }
    @default {
      @if (route) {
        <a [routerLink]="route" [title]="value">{{ value }}</a>
      } @else if (url) {
        <a [href]="url" [title]="value" target="_blank">{{ value }}</a>
      } @else {
        @if (options) {
          {{ getOptionText() | translate }}
        } @else {
          <span [style]="{ color: column?.color }" [title]="value">{{ value }}</span>
        }
      }
    }
  }
</ng-template>
